const $chatbotAppElement = $('#chatbot-app');
const RED_PAGETYPE = 'red-chatbot';

$(document).ready(function () {
  if ($chatbotAppElement && $chatbotAppElement.length) {
    initialize();
  }
});

function initialize() {

  if (!window.ChatbotAI_track) {
    console.error('ERROR: ChatbotAI_track function does not exists | EVENTS TRACKING IS NOT INITIALIZED');
    return;
  }

  $chatbotAppElement.on('chatbot:init', function(e, params) {
    window.ChatbotAI_track('chat opened', {
      page_type: RED_PAGETYPE,
      conversationID: params.chatThreadId
    });
  });

  $chatbotAppElement.on('chatbot:stop', function(e, params) {
    window.ChatbotAI_track('chat closed', {
      page_type: RED_PAGETYPE,
      conversationID: params.chatThreadId
    });
  });

  $chatbotAppElement.on('chatbot:onLoginClick', function(e, params) {
    window.ChatbotAI_track('chat login', {
      page_type: RED_PAGETYPE,
      conversationID: params.chatThreadId
    });
  });

  $chatbotAppElement.on('chatbot:loginSubmitted', function(e, params) {
    const trackingLoginObj = {
      page_type: RED_PAGETYPE,
      conversationID: params.chatThreadId,
      customer_email: params.chatUserProfile.email,
      customer_id: params.chatUserProfile.customerNo,
      customer_cc_id: params.chatUserProfile.customerNo,
      customer_sc_id: params.chatUserProfile.customerSfscID
    };
    window.ChatbotAI_track('chat login-submitted', trackingLoginObj);
  });

  $chatbotAppElement.on('chatbot:subscribe', function(e, params) {
    window.ChatbotAI_track('chat subscribe', {
      page_type: RED_PAGETYPE,
      conversationID: params.chatThreadId
    });
  });

  $chatbotAppElement.on('chatbot:onSuggestedProductClick', function(e, params) {
    const product = params.item;
    const trackingSuggestedProductObject = {
      product_id: product.masterID,
      product_id_mfc: product.id,
      product_name: product.name,
      product_unit_price: product.decimalPrice,
      product_category: product.raw.subCategory,
      page_type: RED_PAGETYPE,
      conversationID: params.chatThreadId
    };
    window.ChatbotAI_track('chat click suggested product', trackingSuggestedProductObject);
  });

  $chatbotAppElement.on('chatbot:messageSent', function(e, params) {
    window.ChatbotAI_track('chat message sent', {
      page_type: RED_PAGETYPE,
      conversationID: params.chatThreadId
    });
  });
}